import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import ReactModal from 'react-modal';

import './polyfills';

import '@styles/css';

import { configureSentry } from '@shared/modules/sentry/utils';

configureSentry();

ReactModal.setAppElement('#root');

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(<App />);
}
